import userSlice from './slice/userSlice';
import roleSlice from './slice/roleSlice';
import orgSlice from './slice/orgSlice';

const userAction = userSlice.actions;
const roleAction = roleSlice.actions;
const orgAction = orgSlice.actions;

export { userAction, roleAction, orgAction };
